jQuery(($) => {
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Browser - Keydown Focus Class
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $("body").on("keydown", function () {
    if (!$(".keyboard-in-use")[0]) {
      $(this).addClass("keyboard-in-use");
    }
  });

  $("body").on("mousedown", function () {
    if ($(".keyboard-in-use")[0]) {
      $(this).removeClass("keyboard-in-use");
    }
  });

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Header
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $(window).on('load scroll', function () {
    const scrollY = $(document).scrollTop();
    const header = $('.o-header');

    if (scrollY > 10) {
      header.addClass('o-header--scrolling');
    } else {
      header.removeClass('o-header--scrolling');
    }
  });

  // setTimeout(() => {

  //   // Move the 'make_recurring' element and 'recurring_questions' table
  //   const divElement = document.querySelector('div[data-export="sys:first"]');
  //   const setRecurring = document.getElementById("make_recurring");
  //   const setSchedule = document.getElementById("recurring_questions");
  //   const checkbox = document.getElementById("recurring");

  //   console.log(divElement, setRecurring);
  //   if (divElement && setRecurring) {
  //     // Create a new table element and append 'make_recurring' and 'recurring_questions'
  //     const table = document.createElement('table');

  //     table.appendChild(setRecurring);
  //     table.appendChild(setSchedule);

  //     // Insert the new table before the div element
  //     divElement.insertAdjacentElement('beforebegin', table);
  //     console.log('ran here again');

  //     // Hide the 'make_recurring' element
  //     if (setRecurring) {
  //       setRecurring.style.display = 'none';
  //     }
  //   }

  //   // Pre-select the "Monthly" option in the recurring interval select element
  //   const selectElement = document.querySelector('select[name="recurring_interval"]');
  //   if (selectElement) {
  //     selectElement.value = "1m";

  //     // Remove all options except the one with value "1m"
  //     Array.from(selectElement.options).forEach(option => {
  //       if (option.value !== "1m") {
  //         option.remove();
  //       }
  //     });

  //     // Hide the first and third rows of the 'recurring_questions' table body
  //     const tbodyElement = document.getElementById('recurring_questions');

  //     if (tbodyElement) {
  //       if (tbodyElement.rows.length > 0) {
  //         tbodyElement.rows[0].style.display = 'none'; // Hide the first row
  //       }
  //       if (tbodyElement.rows.length > 2) {
  //         tbodyElement.rows[2].style.display = 'none'; // Hide the third row
  //       }
  //     }
  //   }

  //   const recurringYears = document.querySelector('select[id="recurring_end_years"]');
  //   const recurringMonths = document.querySelector('select[name="recurring_end_months"]');

  //   // Function to select an option by its text in a select element
  //   function selectOptionByText(selectElement, text) {
  //     Array.from(selectElement.options).forEach((option, index) => {
  //       if (option.text === text) {
  //         selectElement.selectedIndex = index; // Set the selected index to the matching option
  //       }
  //     });
  //   }

  //   // Function to update recurring options based on the monthly payment value
  //   function updateRecurringOptions(paymentValue) {
  //     if (paymentValue === 20) {
  //       // Set recurringYears to 2 and recurringMonths to 6
  //       selectOptionByText(recurringYears, "2");
  //       selectOptionByText(recurringMonths, "6");
  //     } else if (paymentValue === 50) {
  //       // Set recurringYears to 1 and recurringMonths to blank
  //       selectOptionByText(recurringYears, "1");
  //       selectOptionByText(recurringMonths, ""); // Select the blank option
  //     } else if (paymentValue === 100) {
  //       // Set recurringYears to 0 and recurringMonths to 6
  //       selectOptionByText(recurringYears, "0");
  //       selectOptionByText(recurringMonths, "6");
  //     }
  //   }

  //   // Function to update the checkbox state based on membership type and payment type
  //   function updateCheckboxState() {
  //     const membershipTypeRadios = document.querySelectorAll('input[name="form_c6bd9726-2f09-44c3-b604-49c73f33f98e"]');
  //     const paymentTypeRadios = document.querySelectorAll('input[name="form_5d5436b0-f2f1-4eae-9ebb-d14043121275"]');
  //     const checkbox = document.getElementById("recurring");

  //     const selectedMembershipType = document.querySelector('input[name="form_c6bd9726-2f09-44c3-b604-49c73f33f98e"]:checked')?.value;
  //     const selectedPaymentType = document.querySelector('input[name="form_5d5436b0-f2f1-4eae-9ebb-d14043121275"]:checked')?.value;

  //     if (checkbox) {
  //       // Check the checkbox based on membership type and payment type
  //       if (selectedMembershipType === "Annual" || (selectedMembershipType === "Lifetime" && selectedPaymentType === "Monthly")) {
  //         checkbox.checked = true;
  //       } else {
  //         checkbox.checked = false;
  //       }
  //     }
  //   }

  //   // Function to initialize event listeners for the monthly payment radio buttons
  //   function initializeRadioListeners() {
  //     const radioButtons = document.querySelectorAll('input[name="form_ab78ab27-2601-4f43-8162-c4e490c3ddc3"]');
  //     radioButtons.forEach(radio => {
  //       radio.addEventListener('change', (event) => {
  //         const paymentValue = parseInt(event.target.value, 10);
  //         updateRecurringOptions(paymentValue); // Update options based on selected radio button
  //         updateCheckboxState(); // Update checkbox state based on current selection
  //       });
  //     });

  //     // Check the initially selected radio button
  //     const selectedRadio = document.querySelector('input[name="form_ab78ab27-2601-4f43-8162-c4e490c3ddc3"]:checked');
  //     if (selectedRadio) {
  //       const paymentValue = parseInt(selectedRadio.value, 10);
  //       updateRecurringOptions(paymentValue); // Update options for the initially selected value
  //       updateCheckboxState(); // Update checkbox state based on initial selection
  //     }
  //   }

  //   // Function to handle changes in the membership type radio group
  //   function handleMembershipTypeChange() {
  //     const membershipTypeRadios = document.querySelectorAll('input[name="form_c6bd9726-2f09-44c3-b604-49c73f33f98e"]');
  //     const paymentTypeRadios = document.querySelectorAll('input[name="form_5d5436b0-f2f1-4eae-9ebb-d14043121275"]');

  //     membershipTypeRadios.forEach(radio => {
  //       radio.addEventListener('change', updateCheckboxState); // Update checkbox state on membership type change
  //     });

  //     paymentTypeRadios.forEach(radio => {
  //       radio.addEventListener('change', updateCheckboxState); // Update checkbox state on payment type change
  //     });

  //     // Check the initially selected radio buttons and update checkbox state
  //     const selectedMembershipType = document.querySelector('input[name="form_c6bd9726-2f09-44c3-b604-49c73f33f98e"]:checked');
  //     const selectedPaymentType = document.querySelector('input[name="form_5d5436b0-f2f1-4eae-9ebb-d14043121275"]:checked');
  //     if (selectedMembershipType || selectedPaymentType) {
  //       updateCheckboxState();
  //     }
  //   }

  //   // Create a MutationObserver to detect when the radio buttons are added to the DOM
  //   const observer = new MutationObserver((mutationsList, observer) => {
  //     for (let mutation of mutationsList) {
  //       if (mutation.type === 'childList') {
  //         const radioButtons = document.querySelectorAll('input[name="form_ab78ab27-2601-4f43-8162-c4e490c3ddc3"]');
  //         if (radioButtons.length > 0) {
  //           // Initialize listeners for the monthly_payment radio buttons
  //           initializeRadioListeners();
  //         }

  //         const membershipTypeRadios = document.querySelectorAll('input[name="form_c6bd9726-2f09-44c3-b604-49c73f33f98e"]');
  //         if (membershipTypeRadios.length > 0) {
  //           // Initialize listeners for the membership_type radio buttons
  //           handleMembershipTypeChange();
  //         }

  //         const paymentTypeRadios = document.querySelectorAll('input[name="form_5d5436b0-f2f1-4eae-9ebb-d14043121275"]');
  //         if (paymentTypeRadios.length > 0) {
  //           // Initialize listeners for the payment_type radio buttons
  //           handleMembershipTypeChange();
  //         }
  //       }
  //     }
  //   });


  //   // Start observing the document body for added nodes
  //   observer.observe(document.body, { childList: true, subtree: true });

  // }, 1000);
});
